<template>
  <ul class="resultItem_wrap">
    <li
        v-for="(item,index) in check"
        :key="index"
        class="resultItem">
        <el-row class="resultItem_title">
          <el-col :span="22">{{ check.length - index}}审结果</el-col>
          <el-col :span="2" v-show="index">
              <el-button type="text" @click="toggleBtn(index)" >{{tipShow === index ? `收起`:`展开`}}</el-button>
          </el-col>
        </el-row>
        <el-collapse-transition>
        <el-row v-show="tipShow === index || index === 0 " class="resultItem_textarea">
            <el-col :span="12">
                <el-form
                label-width="90px"
                class="demo-form-inline edit_from"
                ref="editForm"
                >
                <el-form-item label="资料时间点:" prop="name" style="margin-bottom: 16px;">
                    <el-input v-model="item.data_datetime" type="textarea"  placeholder="请输入资料时间点" :disabled="index !==0" @blur="changeInput({data_datetime: item.data_datetime})"></el-input>
                </el-form-item>
                </el-form>
            </el-col>
            <el-col :span="12">
                <el-form
                label-width="60px"
                class="demo-form-inline edit_from"
                ref="editForm"
                >
                <el-form-item label="备注:" prop="name" style="margin-bottom: 16px;">
                    <el-input v-model="item.remark" type="textarea"  placeholder="请输入备注信息" :disabled="index !==0" @blur="changeInput({remark:item.remark })"></el-input>
                </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        </el-collapse-transition>
    </li>
  </ul>
</template>

<script>
import { mixin } from '../constant/mixin'
export default {
  name: 'questionList',
  props: {
    check: {
      type: Array,
      default () {
        return []
      }
    },
    form: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
  },
  computed: { },

  created () {
  },
  data () {
    return {
      tipShow: ''
    }
  },
  mixins: [mixin],
  methods: {
    toggleBtn (index) {
      let toggleReault = this.tipShow === index ? this.tipShow = !index : this.tipShow = index
      return toggleReault
    },
    changeInput (val) {
      let isItem = true
      val && this.logicalHandler(this.form, isItem)
      this.$emit('upCheck', val)
    }

  }
}
</script>

<style lang="scss" scoped>
.resultItem{
    &_title{
        background: #FAFAFA;
        font-size:13px;
        color:#595959;
        height:48px;
        border-radius: 8px;
        line-height: 48px;
        padding-left:12px;
        margin-top:24px;
    }
    &_textarea{
        margin-top:16px
    }
}
</style>
